import React, { useRef } from 'react';

import { clsx } from '@interlayer/js/app/utils/clsx.util';

import { HoverBlock } from '../HoverBlock';

import style from '../../DetailedTile.scss';

export const WrapTileWithTitle = ({
    children,
    isTitle,
    gameCodes,
    gameData,
    title,
    viewModeInline,
    classNames,
    feedName,
    handlerLaunchGame
}) => {
    const gameTileWithTitleRef = useRef(null);

    if (!isTitle) {
        return children;
    }

    return (
        <div
            ref={gameTileWithTitleRef}
            className={clsx(style.gameTileWithTitle, { [style.isInlineMode]: viewModeInline })}
            onClick={handlerLaunchGame}
        >
            {children}

            {(title || gameData.name) && (
                <div className={style.gameTitle}>{title || gameData.name}</div>
            )}

            <HoverBlock
                isShowInfo
                feedName={feedName}
                gameData={gameData}
                gameCodes={gameCodes}
                classNames={classNames}
                containerRef={gameTileWithTitleRef}
            />
        </div>
    );
};
